/* eslint-disable react-hooks/exhaustive-deps */
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { contractService } from '../../utils/helpers/observer';
import { FilterApi } from '../../utils/api';
import AutocompleteComponent from '../../components/common/component/AutocompleteComponent';
import CpoError from '../../components/common/CpoError';
import { Toast } from 'primereact/toast';
import { resetImputLabel } from '../../utils/helpers/module/filtersHelper';
import { addContractToUser, saveContracts, TableComponent } from '../../utils/helpers/ContractUsersHelper';
import { loaderDataComponent } from '../../utils/helper';
import { UserContext } from './AdministrationView';

const ContractUsers = () => {
  const adminstrationViewContext = useContext(UserContext);
    // dropdownlists
  const [cpoData, setCpoData] = useState([]);
  const [contractsCpoNotAssigned, setContractsCpoNotAssigned] = useState<any>(
    [],
  );
  // table
  const [contractsUser, setContractsUser] = useState<any[]>([]);
  // values selected
  const [userSelected, setUserSelected] = useState<any>({});
  const [cpoSelected, setCpoSelected] = useState('');
  // loading state
  const [loading, setLoading] = useState<boolean>(false);
  // force update dom with hook setter
  const [, updateState] = React.useState<any>();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [codeStatus, setCodeStatus] = useState<any>('200');
  const [warning, setWarning] = useState<boolean>(false);
  // toast
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);

  //Listes des CPO pour les admins
  const getCPO = async () => {
    setLoading(true);
    try {
      const response = await FilterApi.getCpos();
      setCpoData(response?.data);
      setCodeStatus(response?.status);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  // function to get all contracts already assigned to user selected
  const getContractsForUserSelected = async (email: string | null) => {
    setLoading(true);
    try {
      const response = await FilterApi.getUserContracts(email);
      setContractsUser(response?.data);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  // function to get lists of contracts assigned and not
  const getContractsAssignedAndNot = async (
    cpo: string,
    contractsOfUser: any[],
  ) => {
    setLoading(true);
    try {
      // get contracts by cpo selected
      const response = await FilterApi.getContract(cpo);
      const allContractsByCpoSelected: any[] = response?.data;
      if (allContractsByCpoSelected.length === 0) {
        setWarning(true);
      }

      // delete contracts already assigned for user
      if (contractsOfUser.length !== 0) {
        contractsOfUser.forEach((contract: any) => {
          const idToDelete = allContractsByCpoSelected.findIndex(
            (value: any) => contract.contractId === value.contractId,
          );
          if (idToDelete !== -1) {
            // delete dupplicate
            allContractsByCpoSelected.splice(idToDelete, 1);
          }
        });
      }

      // update lists of contracts to assign
      setContractsCpoNotAssigned(allContractsByCpoSelected);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  // component did mount
  useEffect(() => {
    contractService.setContract(
      window.sessionStorage.getItem('contractCode') || '',
    );
  }, []);

  return (
    <Container className='contractContainer'>
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      <Container
        className='contentContainer'
        style={{ width: '100%', height: '100%', overflow: 'auto'}}
      >
        <CpoError statusCode={codeStatus} />
        <Word
          value='GESTION DES CONTRATS PAR UTILISATEUR'
          textStyle='title'
          variant='span'
          automatedTestId='contract-title'
          className='contract-title'
        />
        <br />
        <Container className='adminCpo'>
          {/* select user */}
          <Word
            value='Utilisateur'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-user'
            className='fieldLabel'
          />
          <AutocompleteComponent
            id='dropdownUser'
            Listoption={adminstrationViewContext.userData.map((c: any) => {
              return { name: c.email, id: c.id };
            })}
            onChangeValue={(event, option: any) => {
              // delete warning message
              setWarning(false);
              if (option !== null) {
                getCPO();
                setUserSelected(option);
                getContractsForUserSelected(option.name);
              } 
              // reset to null table and dropdownlists
              setCpoData([]);
              setContractsUser([]);
              setContractsCpoNotAssigned([]);
              forceUpdate();
              // reset input value of main activiy dropdownlist and for section dropdownlist
              resetImputLabel('dropdownCpo');
              resetImputLabel('dropdownContracts');
            }}
            placeholder='Choisir un utilisateur'
          />
          <br />
          {/* select cpo */}
          <Word
            value='Cpo'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-cpo'
            className='fieldLabel'
          />
          <AutocompleteComponent
            id='dropdownCpo'
            Listoption={cpoData.map((c: any) => {
              return { name: c };
            })}
            onChangeValue={(event, option: any) => {
              // delete warning message
              setWarning(false);
              if (option !== null) {
                // get contracts assigned to user and provide data to contracts dropdownlist and table
                let userContractsByCpoSelected = contractsUser.filter(
                  (contract: any) => contract.cpo === option.name,
                );
                getContractsAssignedAndNot(
                  option.name,
                  userContractsByCpoSelected,
                );
                setCpoSelected(option.name);
              } else {
                // reset to null table and dropdownlists
                setContractsCpoNotAssigned([]);
                // reset input value of main activiy dropdownlist and for section dropdownlist
                resetImputLabel('dropdownContracts');
              }
            }}
            placeholder='Choisir un Cpo'
          />
          <br />
          {/* select contracts */}
          <Word
            value='Contrats'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-contracts'
            className='fieldLabel'
          />
          <AutocompleteComponent
            id='dropdownContracts'
            Listoption={contractsCpoNotAssigned.map((c: any) => {
              return {
                name: c.contractLabel + ' - ' + c.contractCode,
                id: c.contractId,
                contractCode: c.contractCode,
                contractId: c.contractId,
              };
            })}
            onChangeValue={(event, option: any) => {
              if (option !== null) {
                addContractToUser(
                  contractsUser,
                  userSelected,
                  cpoSelected,
                  option,
                  contractsCpoNotAssigned,
                  setContractsCpoNotAssigned,
                  setContractsUser,
                  forceUpdate,
                );
              }
            }}
            placeholder='Choisir un contrat'
          />
        </Container>
        {/* warning */}
        {warning && (
          <span
            style={{
              alignSelf: 'center',
              color: 'red',
            }}
          >
            Aucun contrat affecté au CPO
          </span>
        )}
        {/* table of users' contracts */}
        {<div style={{ width: '70%', marginLeft: 'auto', marginRight: 'auto' }}>
          <TableComponent
            pData={contractsUser}
            contractsCpoNotAssigned={contractsCpoNotAssigned}
            setContractsCpoNotAssigned={setContractsCpoNotAssigned}
            setContractsUser={setContractsUser}
            forceUpdate={forceUpdate}
            cpoSelected={cpoSelected}
          />
        </div>}
        <br />
        <br />
        {/* validate contracts */}
        {contractsUser.length > 0 && (
          <Container style={{ alignItems: 'center' }}>
            <div
              style={{
                backgroundColor: '#63D1B5',
                borderRadius: '40px',
                padding: '10px',
              }}
            >
              <Button
                type='button'
                mode='basic'
                onClick={() => {
                  saveContracts(
                    setLoading,
                    userSelected,
                    contractsUser,
                    toastSucess,
                    toastError,
                  );
                }}
              >
                <Word
                  value='Valider'
                  textStyle='normalBold'
                  variant='span'
                  automatedTestId='contract-valider'
                  className='contract-valider'
                />
              </Button>
            </div>
          </Container>
        )}
      </Container>
      < br />
      {loaderDataComponent(loading)}
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
  color: black;
.css-1s2u09g-control{
    background-color: #edf2fa;
}
.css-6j8wv5-Input{
    font-family: "Montserrat";
    font-size: 12px;
    font-style: Italic;
}
.contractContainer{

  .contract-modal{
    .modal-flex-desktop-header{
      display:none !important;
    }
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    top: 10%;
    bottom: 10%;
    height: auto;
    width: 60%;
  }
  
.fieldLabel,.elementList{
  margin-bottom:5px;
  text-align: start;
}
.contract-title{
  margin-top: 10px;
  text-align: center;
}
.contract-cancel{
  margin-top: 250px;
  text-decoration:underline;
}
.cancel{
  margin-left: auto;
  margin-right: auto;
}
.adminCpo{
  margin-bottom: 50px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  .dropdown-list{
    text-align: start;
    z-index:50;
  }
}
.contentContainer{
  margin-left: auto;
  margin-right: auto;
}
.dropdown-list{
  z-index:30;
}
.loaderContainer{
  margin-top:0px;
}
  }
}
`;
export default ContractUsers;
